import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styleProg from '../css/backgrounds/trademarks.module.css';
import '../css/AllServices.css';

function Intellpropservices() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <div className="services-name">
            <div className={`${styleProg.back1} service-item`} ref={(el) => addToRefs(el, 0)}>
                <h1>العلامات التجارية</h1>
                <div>
                    <span><Link to='/services/trademarks'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966540062640?text=السلام عليكم. عندي استفسار بخصوص العلامات التجارية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back2} service-item`} ref={(el) => addToRefs(el, 1)}>
                <h1>تسجيل براءة اختراع</h1>
                <div>
                    <span><Link to='/services/patent'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966540062640?text=السلام عليكم. عندي استفسار في تسجيل براءة الاختراع'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back3} service-item`} ref={(el) => addToRefs(el, 2)}>
                <h1>تسجيل منتج صناعي</h1>
                <div>
                    <span><Link to='/services/indusproduct'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966540062640?text=السلام عليكم. اريد اسئل عند تسجيل منتج صناعي'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back4} service-item`} ref={(el) => addToRefs(el, 3)}>
                <h1>تسجيل حقوق نشر</h1>
                <div>
                    <span><Link to='/services/copyright'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966540062640?text=السلام عليكم. اريد استفسر عن تسجيل حقوق النشر'>أطلب الان</Link>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Intellpropservices